import axios from "axios";
import DataService from "../../services/data.service";
const handleUnauthorized = () => {
  DataService.deleteAccessToken();
  window.location.href = '/login'
};

axios.interceptors.request.use(
  config => {
   const token = DataService.getAccessToken();
   if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
   }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  function (error) {
    console.log(error);
    const originalRequest = error.config;
    const isLoginRequest =originalRequest.url.includes('login');
    if (error.response && error.response.status === 401 && !isLoginRequest) {
      handleUnauthorized()
    }
    return Promise.reject(error);
  }
);